export const isMatchStoreByUrl = () => process.env.NEXT_PUBLIC_BH_MATCH_STORE_BY === 'url'

export const isMatchStoreByDevUrl = () => process.env.NEXT_PUBLIC_BH_MATCH_STORE_BY === 'dev-url'

export const isMatchStoreByCodeInPath = () => process.env.NEXT_PUBLIC_BH_MATCH_STORE_BY === 'code-in-path'

export const isMatchStoreByNone = () => !isMatchStoreByUrl() && !isMatchStoreByCodeInPath()

export const isMatchStoreBySomething = () => isMatchStoreByUrl() || isMatchStoreByDevUrl() || isMatchStoreByCodeInPath()
